import React, { Component } from 'react'
import {Tabs,Tab,Grid,Cell,Card,CardTitle,CardActions,Button,CardMenu,IconMenu,IconButton,CardText} from 'react-mdl';
export default class Projects extends Component {
  constructor(props){
    super(props);
    this.state = { activeTab: 0};
  }

 toggleCategories(){
  if(this.state.activeTab===0)
  {
    return(
<div className="projects-grid">
<Card shadow={5} style={{minwidth: '450', margin: 'auto'}}>
      <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://cdn-images-1.medium.com/max/1200/1*y6C4nSvy2Woe0m7bWEn4BA.png) center / cover'}}>React Project</CardTitle>
      <CardText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Mauris sagittis pellentesque lacus eleifend lacinia...
      </CardText>
      <CardActions border>
          <Button colored>Github</Button>
          <Button colored>CodePen</Button>
          <Button colored>LiveDemo</Button>
      </CardActions>
      <CardMenu style={{color: '#fff'}}>
          <IconButton name="share" />
      </CardMenu>
  </Card>
  <Card shadow={5} style={{minwidth: '450px', margin: 'auto'}}>
      <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://cdn-images-1.medium.com/max/1200/1*y6C4nSvy2Woe0m7bWEn4BA.png) center / cover'}}>React Project</CardTitle>
      <CardText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Mauris sagittis pellentesque lacus eleifend lacinia...
      </CardText>
      <CardActions border>
          <Button colored>Github</Button>
          <Button colored>CodePen</Button>
          <Button colored>LiveDemo</Button>
      </CardActions>
      <CardMenu style={{color: '#fff'}}>
          <IconButton name="share" />
      </CardMenu>
  </Card>

  
  <Card shadow={5} style={{minwidth: '450px', margin: 'auto'}}>
      <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://cdn-images-1.medium.com/max/1200/1*y6C4nSvy2Woe0m7bWEn4BA.png) center / cover'}}>React Project</CardTitle>
      <CardText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Mauris sagittis pellentesque lacus eleifend lacinia...
      </CardText>
      <CardActions border>
          <Button colored>Github</Button>
          <Button colored>CodePen</Button>
          <Button colored>LiveDemo</Button>
      </CardActions>
      <CardMenu style={{color: '#fff'}}>
          <IconButton name="share" />
      </CardMenu>
  </Card>
</div>
    )


    
  }else if (this.state.activeTab===1)
  {
    return(
      <div><h1>This is Node JS</h1></div>
    )
  }else if (this.state.activeTab===2)
  {
    return(
      <div><h1>This is Mongo DB</h1></div>
    )
  }
 }

  render() {
    return (
      <div>
         <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
                    <Tab>React</Tab>
                    <Tab>Node JS</Tab>
                    <Tab>Mongo DB</Tab>
         </Tabs>
         <section>
         <Grid >
         <Cell col={12}>
      <div className="content">
      {this.toggleCategories()}
      </div>
         </Cell>
         </Grid>
         
         </section>
      </div>
    )
  }
}
